import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as stm from '../stm'

export const RESOURCE = {
  payload: {
    alias: 'chat',
    appAlias: stm.RESOURCE.payload.alias,
    description: 'Understand where your team is focused',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Chat',
    page: { id: prebuilt.Page.Id.StmChat },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
